import React from 'react'
import clsx from 'clsx'
import SvgIcon from '@mui/material/SvgIcon'
import { IconProps } from './index'
import styles from './Icon.module.scss'

const LinkIcon: React.FC<IconProps> = ({ className, alt }) => {
  return (
    <SvgIcon
      className={clsx(styles.IconStroke, className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.3565 12.6224L18.2229 10.756C19.5973 9.38163 19.5973 7.15283 18.2229 5.77763V5.77763C16.8485 4.40323 14.6197 4.40323 13.2445 5.77763L11.3781 7.64403"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.51251 14.488L14.4885 9.51202"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.64409 11.3776L5.77769 13.244C4.40329 14.6184 4.40329 16.8472 5.77769 18.2224V18.2224C7.15209 19.5968 9.38089 19.5968 10.7561 18.2224L12.6225 16.356"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export default LinkIcon
